import lunr from 'lunr'

export default class LunrWrapper {
  constructor(records, fields, separator) {
    if (separator) lunr.tokenizer.separator = separator

    this.reindex(records, fields)
  }

  reindex(records, fields) {
    this.records = records

    this.dict = {}
    const t = this
    this.index = lunr(function() {
      this.pipeline.remove(lunr.stemmer)
      this.pipeline.remove(lunr.stopWordFilter)

      this.ref('_id')

      for (const field of fields) {
        this.field(field)
      }

      t.dict = {}
      for (const doc of records) {
        this.add(doc)
        t.dict[doc._id] = doc
      }
    })
  }

  query(term) {
    if (!term) {
      return this.records
    }

    const res = this.index.query(q => {
      // use lunr.tokenizer.separator for splitting words:
      const words = term.split(lunr.tokenizer.separator)

      for (const word of words) {
        q.term(word.toLowerCase(), {
          wildcard: lunr.Query.wildcard.TRAILING,
          presence: lunr.Query.presence.REQUIRED
        })
      }
    })

    return res.map(meta => this.dict[meta.ref])
  }
}
